import { Injectable } from '@angular/core';

import {
  ControlValidator,
  ControlValidatorType,
  ControlValidateMoment,
  ControlValidatorError
} from '../../types/validator.types';
import { AbstractControl } from '../../types/control.types';
@Injectable()
export class UnionCHeckValidator extends ControlValidator {
  type = ControlValidatorType.UnionCheck;

  validateMoment = ControlValidateMoment.Blur;
  unionTargetControl: AbstractControl<any>;
  constructor() {
    super();
    this.error = new ControlValidatorError(false, '');
  }

  validate(): ControlValidatorError {
    // æªæ¾å°æ§ä»¶ï¼é»è®¤è®¤ä¸ºæå
    if (!this.unionTargetControl) {
      return this.validSuccess();
    }

    if (!this.isEmpty(this.control.model.value) || !this.isEmpty(this.unionTargetControl.model.value)) {
      return this.validSuccess();
    }
    return this.setErrorFalse();
  }

  bindUnionTargetControl(targetControl: AbstractControl<any>) {
    this.unionTargetControl = targetControl;
  }

  private setErrorFalse(): ControlValidatorError {
    this.error.success = false;
    this.error.message = this.model.errorMessage;
    return this.error;
  }

  isEmpty(data: any): boolean {
    if (data === undefined || data === '') {
      return true;
    }

    if (typeof data === 'object') {
      if (data instanceof Array) {
        if (data.length === 0) {
          return true;
        }
      }

      if (data === null) {
        return true;
      }

      if (JSON.stringify(data) === '{}') {
        return true;
      }
    }

    return false;
  }

  private validSuccess(): ControlValidatorError {
    this.error.message = '';
    this.error.success = true;
    return this.error;
  }
}
